import { generateUUID } from '$lib/helper/uuid';
import type { Area } from '$lib/model/area';
import type { SessionInstance } from '$lib/model/booking';
import type { TimeslotMinute } from '$lib/model/openingHour';
import type { Session } from '$lib/model/session';
import type { Axios } from 'axios';
import { DateTime } from 'luxon';
import { get, writable } from 'svelte/store';
import { apiStore } from './api';
import { calendarDateRange } from './calendarDates';

export const sessionInstanceStore = writable<SessionInstance[]>([]);

export function clearSessionInstanceStore() {
	sessionInstanceStore.set([]);
}
export function loadSessionInstance(date: DateTime | undefined = undefined, offset = 0) {
	const offsetLoading = 250;
	(get(apiStore) as Axios)
		.post('/session-instance/search?offset=' + offset + '&limit=' + offsetLoading, {
			startDate: (date ?? get(calendarDateRange).start).toISODate(),
			endDate: (date ?? get(calendarDateRange).end).toISODate()
		})
		.then((res) => {
			sessionInstanceStore.set([
				...(date
					? get(sessionInstanceStore).filter(
							(sessionInstance) => !sessionInstance.date.hasSame(date, 'day')
						)
					: get(sessionInstanceStore)),
				...res.data.map((sessionInstance) => ({
					...sessionInstance,
					date: DateTime.fromISO(sessionInstance.date)
				}))
			]);

			if (res.data.length === offsetLoading) {
				loadSessionInstance(date, offset + offsetLoading);
			}
		});
}

export function sortSessionInstances(a: SessionInstance, b: SessionInstance): number {
	return a.start - b.start;
}

export function createNewSessionInstance(
	timeslot: TimeslotMinute,
	date: DateTime,
	area: Area,
	sessionId: Session['id']
): SessionInstance {
	return {
		sessionInstanceId: generateUUID(),
		start: timeslot.start,
		end: timeslot.end,
		date,
		sessionId: sessionId,
		areaId: area.id
	};
}

export const planningItemsClickObservers = new Set<
	(sessionInstance: SessionInstance, date: DateTime, area: Area) => void
>();
export function planningItemClick(sessionInstance: SessionInstance, date: DateTime, area: Area) {
	planningItemsClickObservers.forEach((observer) => observer(sessionInstance, date, area));
}
export function planningItemClickAddObserver(
	observer: (sessionInstance: SessionInstance, date: DateTime, area: Area) => void
): () => void {
	planningItemsClickObservers.add(observer);
	return () => planningItemsClickObservers.delete(observer);
}
